import script from "./AnalisisView.vue?vue&type=script&setup=true&lang=js"
export * from "./AnalisisView.vue?vue&type=script&setup=true&lang=js"

import "./AnalisisView.vue?vue&type=style&index=0&id=1b2503d8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1b2503d8"]])

export default __exports__